// extracted by mini-css-extract-plugin
export var actionButton = "_dh-0";
export var attachmentLine = "_dh-1";
export var fileInput = "_dh-2";
export var fileUploadWrapper = "_dh-4";
export var footer = "_dh-3";
export var modalContent = "_dh-5";
export var paperclip = "_dh-6";
export var quillEditor = "_dh-7";